import React from 'react';
import { sanitizeHtml } from 'javascripts/utils';

interface Props {
  element: React.ReactElement;
  html: string;
  addAttributes?: string[];
}

// For inserting server-generated html snippets into React components.
// In most other cases the default React escaping behavior - e.g. (<div> {value} </div>) -
// is preferable to sanitization because sanitized html may still break the UI.
const SanitizeInnerHTML: React.FC<Props> = ({
  element,
  html,
  addAttributes = [],
}) => {
  const sanitized = sanitizeHtml(html, addAttributes);
  return React.cloneElement(element, {
    dangerouslySetInnerHTML: { __html: sanitized }, // not so dangerous now!
  });
};

export default SanitizeInnerHTML;
